'use strict';

function controller ($timeout, adService) {
    const ctrl = this;
    ctrl.name = 'nativeTwinAd';
    let clickImps = {};

    ctrl.fireImpression = fireImpression;

    ctrl.$onInit = function() {
        if (ctrl.defaultTargeting && ctrl.slotNames) {
            $timeout(()=> {
                adService.makeNativeAdCall({
                    name: 'twin.left',
                    defaultTargeting: ctrl.defaultTargeting,
                    slotName: ctrl.slotNames.twinleft,
                }).then((data) => {
                    ctrl.twinleft = data;
                    if (data.impressionURLs){ adService.fireImpression(data.impressionURLs); }
                    clickImps.twinLeft = data.clickImpressionURLs;

                });

                adService.makeNativeAdCall({
                    name: 'twin.right',
                    defaultTargeting: ctrl.defaultTargeting,
                    slotName: ctrl.slotNames.twinright,
                }).then((data) => {
                    ctrl.twinright = data;
                    if (data.impressionURLs){ adService.fireImpression(data.impressionURLs); }
                    clickImps.twinRight = data.clickImpressionURLs;
                });


                adService.makeNativeAdCall({
                    name: 'twin.bed',
                    defaultTargeting: ctrl.defaultTargeting,
                    slotName: ctrl.slotNames.twinbed,
                }).then((data) => {
                    ctrl.twinbed = data;
                    if (data.impressionURLs){ adService.fireImpression(data.impressionURLs); }
                    clickImps.twinBed = data.clickImpressionURLs;
                });
            }, 0);
        }
    };

    function fireImpression(slot){
        if (slot == 'l') {
            adService.fireImpression(clickImps.twinLeft);
        } else if (slot == 'r') {
            adService.fireImpression(clickImps.twinRight);
        } else if (slot == 'b') {
            adService.fireImpression(clickImps.twinBed);
        }
    }
}

controller.$inject = ['$timeout', 'adService'];

export default controller;
